import { DashboardWidget } from '../../Dashboard/DashboardWidget/DashboardWidget';

const def: DashboardWidgetDefinition = {
    id: 'unlinked_funded_accounts',
    title: 'Unlinked Funded Accounts',
    type: 'portfolio',
    queryMeta: {
        dataVariant: 'report',
    },
    filters: [
        {
            id: 'isMirrorLinked',
            value: false,
        },
        {
            id: 'nav',
            value: { gt: '0' },
        },
    ],
    columnIds: [
        'tradeDate',
        'aC',
        'portfolioGuid',
        'householdName',
        'nav',
        'cash',
        'isClientDirected',
        'isSuspended',
        'suspendedAt',
        'isMirrorLinked',
        'referencePortfolio',
        'accountType',
        'brokerId',
    ],
};

export const UnlinkedFundedAccounts = () => <DashboardWidget widgetDefinition={def} />;
